import { HeroUIPluginConfig } from "@heroui/react";

export const theme: HeroUIPluginConfig = {
  layout: {
    radius: {
      small: "0.25rem",
      medium: "0.5rem",
      large: "0.75rem",
    },
    borderWidth: {
      small: "0.5px",
      medium: "1px",
      large: "2px",
    },
  },
  themes: {
    light: {
      colors: {
        primary: {
          "50": "#F9E8E9",
          "100": "#F3D2D4",
          "200": "#E8A5AA",
          "300": "#DD7880",
          "400": "#D24B56",
          "500": "#C71F2C",
          "600": "#9F1823",
          "700": "#77121A",
          "800": "#4F0C11",
          "900": "#270608",
          DEFAULT: "#C71F2C",
        },
        success: {
          foreground: "#ffffff",
          DEFAULT: "#12a150",
        },
      },
    },
  },
};
